<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch8" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="12" id="pg_12" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch8" id="ch8" title="Link target outside of Sample"><b><i>Doing Without</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">I find ways to numb the pain.</p>
<p class="VSB">I write.</p>
<p class="VSB">I release.</p>
<p class="V">And then I hide the notebooks under the blue</p>
<p class="VSB">shag carpet</p>
<p class="VSB">in the broom closet.</p>
<p class="VSB">I keep your world immaculate.</p>
<p class="V">I try to please you when I know there is no</p>
<p class="V">way to please someone <i>who is displeased</i></p>
<p class="VSB"><i>with life.</i></p>
<p class="VSB">I manage—<i>doing without,</i></p>
<p class="V">so your lifestyle does not change. The</p>
<p class="V">children you take credit for are so beautiful.</p>
<p class="VSB">I wish you knew</p>
<p class="VSB">them.</p>
<p class="VSB">I ask myself:</p>
<p class="V">“How can I hate you, when you gave me</p>
<p class="V">something so beautiful?”</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter8.vue?f09e24b2